// extracted by mini-css-extract-plugin
export default {"outerDiv":"verticals-page_outerDiv__4b9Y0","addBtn":"verticals-page_addBtn__uDnGl"};